export default __webpack_public_path__ + "static/media/folders.a9fd17f5.png";